module.exports = __webpack_public_path__ + "static/img/headline-fabric.9a4b4a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/layout/headline/en/headline-fabric.png
// module id = 510
// module chunks = 63